export default __webpack_public_path__ + "static/megan alvarez-d84c7aa5bb013f2ccbde3134eeef7a96.png";